import ModalInfoFormatController from './modal.info.format.controller';

export default {
    template: require('./modal.info.format.tpl.html'),
    controller: ModalInfoFormatController,
    bindings: {}
};
